__turbopack_context__.v({
  "cardToolAction": "tables-module__IAk2Xq__cardToolAction",
  "cardToolEmpty": "tables-module__IAk2Xq__cardToolEmpty",
  "cardToolTrigger": "tables-module__IAk2Xq__cardToolTrigger",
  "emptyCell": "tables-module__IAk2Xq__emptyCell",
  "numeric": "tables-module__IAk2Xq__numeric",
  "priceAsk": "tables-module__IAk2Xq__priceAsk",
  "priceBid": "tables-module__IAk2Xq__priceBid",
  "root": "tables-module__IAk2Xq__root",
  "rowAction": "tables-module__IAk2Xq__rowAction",
  "rowActionDanger": "tables-module__IAk2Xq__rowActionDanger",
  "rowActions": "tables-module__IAk2Xq__rowActions",
  "scrollX": "tables-module__IAk2Xq__scrollX",
  "search": "tables-module__IAk2Xq__search",
  "stickyHeader": "tables-module__IAk2Xq__stickyHeader",
  "table": "tables-module__IAk2Xq__table",
  "tableComfortable": "tables-module__IAk2Xq__tableComfortable",
  "tableZebra": "tables-module__IAk2Xq__tableZebra",
  "tabular": "tables-module__IAk2Xq__tabular",
  "toolBtn": "tables-module__IAk2Xq__toolBtn",
  "toolBtnActive": "tables-module__IAk2Xq__toolBtnActive",
  "toolbar": "tables-module__IAk2Xq__toolbar",
  "toolbarLeft": "tables-module__IAk2Xq__toolbarLeft",
  "toolbarRight": "tables-module__IAk2Xq__toolbarRight",
  "virtualRoot": "tables-module__IAk2Xq__virtualRoot",
});
